import GetPlan from './GetPlan';
import {
  FULL_PLAN,
  PRODUCERS_PLAN,
  VENUES_PLAN,
} from '../constants';

export default () => {
  const plan = GetPlan();
  if (!plan) { return false; }
  return plan !== PRODUCERS_PLAN && plan !== VENUES_PLAN && plan !== FULL_PLAN;
};



// WEBPACK FOOTER //
// ./src/utils/IsFreePlan.js